var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDripIcon20X20 = function SvgDripIcon20X20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108622",
    d: "M5.077 2.808 7.054 0c2.12 3.116 4.321 6.013 6.157 9.149a7.411 7.411 0 0 1-1.919 9.3 6.712 6.712 0 0 1-9.117-.5 7.754 7.754 0 0 1-1-9.5C2.389 6.55 3.733 4.741 5.077 2.808Z"
  })));
};
export default SvgDripIcon20X20;